export const getGlassStyle = (isDarkMode, variant = 'default') => {
  const isInput = variant === 'input';
  
  // LOGIC: Inputs need to be more opaque (0.85) than standard cards (0.45) 
  // to ensure text entry remains legible on all backgrounds.
  const baseBg = isDarkMode 
    ? (isInput ? 'rgba(0, 0, 0, 0.4)' : 'rgba(255, 255, 255, 0.05)') 
    : (isInput ? 'rgba(255, 255, 255, 0.85)' : 'rgba(255, 255, 255, 0.45)');

  const hoverBg = isDarkMode 
    ? (isInput ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.08)') 
    : (isInput ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.6)');

  const borderColor = isDarkMode 
    ? 'rgba(255, 255, 255, 0.12)' 
    : 'rgba(0, 0, 0, 0.1)';

  const shadow = isDarkMode 
    ? '0 8px 32px 0 rgba(0, 0, 0, 0.37)' 
    : '0 8px 32px 0 rgba(31, 38, 135, 0.15)';

  return {
    container: {
      backgroundColor: baseBg,
      // Performance Tip: Use lower blur for nested inputs (4px vs 16px)
      backdropFilter: isInput ? 'blur(4px) saturate(110%)' : 'blur(16px) saturate(140%)',
      WebkitBackdropFilter: isInput ? 'blur(4px) saturate(110%)' : 'blur(16px) saturate(140%)',
      border: `1px solid ${borderColor}`,
      borderRadius: isInput ? '24px' : '16px',
      boxShadow: isInput ? 'inset 0 1px 2px rgba(0,0,0,0.05)' : shadow,
      transition: 'all 0.2s ease-in-out',
    },
    hover: (e) => {
      e.currentTarget.style.backgroundColor = hoverBg;
      if (!isInput) e.currentTarget.style.transform = 'scale(1.015)';
    },
    leave: (e) => {
      e.currentTarget.style.backgroundColor = baseBg;
      if (!isInput) e.currentTarget.style.transform = 'scale(1)';
    }
  };
};


// export const getGlassStyle = (isDarkMode, scale = 1.015) => {
//   const baseBg = isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.45)';
//   const hoverBg = isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.6)';
//   const borderColor = isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.4)';
  
//   // NEW: Sophisticated shadow that works for both light and dark glass
//   const shadow = isDarkMode 
//     ? '0 8px 32px 0 rgba(0, 0, 0, 0.37)' 
//     : '0 8px 32px 0 rgba(31, 38, 135, 0.15)';

//   return {
//     container: {
//       backgroundColor: baseBg,
//       backdropFilter: 'blur(16px) saturate(140%)',
//       WebkitBackdropFilter: 'blur(16px) saturate(140%)',
//       border: `1px solid ${borderColor}`,
//       borderRadius: '16px',
//       boxShadow: shadow, // Added here: existing components will pick this up
//       transition: 'all 0.3s ease-in-out',
//     },
//     hoverColor: hoverBg,
//     borderColor: borderColor,
//     // JS Event handlers
//     hover: (e) => {
//       e.currentTarget.style.transform = `scale(${scale})`;
//       e.currentTarget.style.backgroundColor = hoverBg;
//       // Ensure shadow stays smooth during scale
//       e.currentTarget.style.boxShadow = isDarkMode 
//         ? '0 12px 40px 0 rgba(0, 0, 0, 0.45)' 
//         : '0 12px 40px 0 rgba(31, 38, 135, 0.25)';
//     },
//     leave: (e) => {
//       e.currentTarget.style.transform = 'scale(1)';
//       e.currentTarget.style.backgroundColor = baseBg;
//       e.currentTarget.style.boxShadow = shadow;
//     }
//   };
// };




// export const getGlassStyle = (isDarkMode, scale = 1.015) => {
//   const baseBg = isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.45)';
//   const hoverBg = isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.6)';
//   const borderColor = isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.4)';

//   return {
//     container: {
//       backgroundColor: baseBg,
//       backdropFilter: 'blur(16px) saturate(140%)',
//       WebkitBackdropFilter: 'blur(16px) saturate(140%)',
//       border: `1px solid ${borderColor}`,
//       borderRadius: '16px',
//       transition: 'all 0.3s ease-in-out',
//     },
//     // Raw values for Grommet component props
//     hoverColor: hoverBg,
//     borderColor: borderColor,
//     // JS Event handlers for non-Grommet containers
//     hover: (e) => {
//       e.currentTarget.style.transform = `scale(${scale})`;
//       e.currentTarget.style.backgroundColor = hoverBg;
//     },
//     leave: (e) => {
//       e.currentTarget.style.transform = 'scale(1)';
//       e.currentTarget.style.backgroundColor = baseBg;
//     }
//   };
// };



// export const getGlassStyle = (isDarkMode, scale = 1.015) => {
//   const baseBg = isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.45)';
//   const hoverBg = isDarkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.6)';

//   return {
//     container: {
//       backgroundColor: baseBg,
//       //backdropFilter: 'blur(16px)',
//       //WebkitBackdropFilter: 'blur(16px)',
//       backdropFilter: 'blur(16px) saturate(140%)',
//       WebkitBackdropFilter: 'blur(16px) saturate(140%)',
//       border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.4)'}`,
//       borderRadius: '16px',
//       transition: 'all 0.2s ease-in-out',
//       cursor: 'pointer',
//     },
//     hover: (e) => {
//       e.currentTarget.style.transform = `scale(${scale})`;
//       e.currentTarget.style.backgroundColor = hoverBg;
//     },
//     leave: (e) => {
//       e.currentTarget.style.transform = 'scale(1)';
//       e.currentTarget.style.backgroundColor = baseBg;
//     }
//   };
// };